import React, { createContext, RefObject, useContext, useRef } from 'react';
import { CampaignType } from '@anytag/graphql';
import { Table as TRTable } from '@tanstack/react-table';
import { PostReportRowData } from './PostReportTable';

interface PostReportContextType {
  hasTracking: boolean;
  campaignType: CampaignType;
  isOnlyTikTokTtcm?: boolean;
  tableRef: RefObject<TRTable<PostReportRowData> | null>;
}

const PostReportContext = createContext<PostReportContextType>({} as PostReportContextType);

export const usePostReportContext = () => useContext(PostReportContext);

interface InfluencerProviderProps {
  children: React.ReactElement | Array<React.ReactElement>;
  value: Pick<PostReportContextType, 'hasTracking' | 'campaignType' | 'isOnlyTikTokTtcm'>;
}

export const PostReportProvider = ({
  children,
  value: { hasTracking, campaignType, isOnlyTikTokTtcm }
}: InfluencerProviderProps) => {
  const tableRef = useRef<TRTable<PostReportRowData>>(null);

  return (
    <PostReportContext.Provider value={{ hasTracking, campaignType, isOnlyTikTokTtcm, tableRef }}>
      {children}
    </PostReportContext.Provider>
  );
};
